import React from 'react';
import { motion } from 'framer-motion';
import Typewriter from './Typewriter';

const SectionHeader = ({ title, subtitle, align = 'left' }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      whileInView={{ opacity: 1, y: 0 }} 
      viewport={{ once: true }} 
      className={`mb-10 md:mb-16 relative ${align === 'center' ? 'text-center' : 'text-left'}`}
    >
      <div className="relative inline-block scanline-overlay px-2">
        <Typewriter as="h2" text={title.toUpperCase()} className="font-orbitron text-2xl md:text-5xl font-bold text-white mb-4 tracking-wider" glow speed={50} />
      </div>
      <div className="mt-4 px-1">
        <Typewriter as="p" text={subtitle} delay={title.length * 50 + 400} speed={30} className="text-gray-400 font-mono text-xs md:text-base max-w-2xl mx-auto block leading-relaxed" />
      </div>
      <div className={`h-[1px] w-12 md:w-24 bg-neon-cyan mt-6 ${align === 'center' ? 'mx-auto' : ''}`}></div>
    </motion.div>
  );
};

export default SectionHeader;